import * as React from "react";
const SvgFiRrSensorAlert = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-sensor-alert_svg__a)">
      <path
        fill="#062147"
        d="M21.998 24H19a1 1 0 1 1 0-2h2.998l-5.991-10.005L9.996 22.01 13 22a1 1 0 1 1 0 2h-2.999a1.98 1.98 0 0 1-1.734-1.004 1.98 1.98 0 0 1 .006-2.004l6.003-10.025a1.98 1.98 0 0 1 1.723-.982c.719 0 1.364.371 1.728.992l5.992 10.006c.372.636.374 1.385.013 2.014A1.98 1.98 0 0 1 21.998 24M17 20v-3a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0M6 23a1 1 0 0 0-1-1c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3v9a1 1 0 1 0 2 0V5c0-2.757-2.243-5-5-5H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5a1 1 0 0 0 1-1M5 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-sensor-alert_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSensorAlert;
